import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import FeaturedPlaces from "../components/FeaturedPlaces";
import HotelsSection from "../components/HotelsSection";
import LatestDiscoveries from "../components/LatestDiscoveries";
import StatsSection from "../components/StatsSection";
import TodaysHighlight from "../components/TodaysHighlight";
import InteractiveMap from "../components/InteractiveMap";
import LiveSvanetiConditions from "../components/LiveSvanetiConditions";
import { useSiteSettings } from "../context/SiteSettingsContext";
import { useLanguage } from "../context/LanguageContext";
import LanguageSync from "../components/LanguageSync";
import AdventuresSection from "../components/AdventuresSection";
import LocalGuidesSection from "../components/LocalGuidesSection";
import CultureSection from "../components/CultureSection";
import TravelGuideSection from "../components/TravelGuideSection";
import PhotoGuideSection from "../components/PhotoGuideSection";
import CuisineSection from "../components/CuisineSection";
import FestivalsSection from "../components/FestivalsSection";
import TopDestinations from "../components/TopDestinations";
import CategoryIconBar from "../components/CategoryIconBar";
import HeroSection from "../components/HeroSection";
import ConstellationBackground from "../components/ConstellationBackground";
import { useHomeOrder } from "../hooks/Usehomeorder";
import { useSEO } from "../hooks/useSEO";
const ACCENT = "#C47C2B";

const getFallbackIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
    <circle
      cx="12"
      cy="12"
      r="9"
      stroke="currentColor"
      strokeWidth="1.6"
      fill="none"
    />
    <path
      d="M12 8V12L15 15"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
    />
  </svg>
);

export default function HomePage() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const settings = useSiteSettings();
  const { language, t } = useLanguage();
  useSEO({
    title: t("home_seo_title"),
    description: t("home_seo_description"),
    ogTitle: t("home_seo_og_title"),
    ogDescription: t("home_seo_og_description"),
    path: `/${language}`,
    noSuffix: true,
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "Discover Svaneti",
      url: "https://discoversvaneti.com",
      description: "Travel guide for Svaneti, Georgia",
    },
  });

  const s = {
    heroEyebrow:
      language === "ka" && settings.heroEyebrowKa
        ? settings.heroEyebrowKa
        : settings.heroEyebrow,
    heroTitle:
      language === "ka" && settings.heroTitleKa
        ? settings.heroTitleKa
        : settings.heroTitle,
    heroSubtitle:
      language === "ka" && settings.heroSubtitleKa
        ? settings.heroSubtitleKa
        : settings.heroSubtitle,
  };

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        const catsSnap = await getDocs(collection(db, "categories"));
        setCategories(catsSnap.docs.map((d) => ({ id: d.id, ...d.data() })));
      } catch (err) {
        console.error("Error loading homepage data:", err);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  const { order } = useHomeOrder();

  const COMPONENTS = {
    CategoryIconBar:       <CategoryIconBar />,
    TopDestinations:       <TopDestinations />,
    InteractiveMap:        <InteractiveMap />,
    FeaturedPlaces:        <FeaturedPlaces />,
    HotelsSection:         <HotelsSection />,
    AdventuresSection:     <AdventuresSection />,
    LocalGuidesSection:    <LocalGuidesSection />,
    CultureSection:        <CultureSection />,
    TravelGuideSection:    <TravelGuideSection />,
    PhotoGuideSection:     <PhotoGuideSection />,
    CuisineSection:        <CuisineSection />,
    FestivalsSection:      <FestivalsSection />,
    LiveSvanetiConditions: <LiveSvanetiConditions />, 
    LatestDiscoveries:     <LatestDiscoveries />,
    StatsSection:          <StatsSection />,
    TodaysHighlight:       <TodaysHighlight />,
  };

  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column", background: "var(--bg-app)", position: "relative" }}>
      <LanguageSync />
      <ConstellationBackground />
      <Navbar />
      <main>
        <HeroSection />

        {order.map((id) => COMPONENTS[id] ? <div key={id}>{COMPONENTS[id]}</div> : null)}
      </main>

      <Footer />
      <style>{`
        @keyframes scrollDot { 0% { transform: translateY(0); opacity: 1; } 100% { transform: translateY(10px); opacity: 0; } }
        @keyframes shimmer { 0%,100%{opacity:.6} 50%{opacity:1} }
      `}</style>
    </div>
  );
}
